import TitleService from 'title-service';
import './MediaPlayerComponent.scss';
import React, { useCallback } from 'react';
import PauseIcon from '@mui/icons-material/Pause';
import { useParams } from 'react-router-dom';
import RedQuickVideo, { RedQuickVideoState } from './RedQuickVideo';
import { useEffect, useState } from 'react';
import Slider from '@mui/material/Slider';
import { uuid } from './util';
import SpeedDial from '@mui/material/SpeedDial';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot } from '@mui/lab';
import {
    TimelineOppositeContent
} from '@mui/lab';
import { useTheme } from '@mui/material/styles';
import { Typography } from '@mui/material';
import SeriesEpisodesPopup, { SeriesEpisode, SeriesSeason } from './SeriesEpisodesPopup';
import CastProvider, { useMedia, useCast } from './chromecast';
import { Series, ApprovedSeries, ProcessedMedia, ApprovedMedia } from 'models';
import SeamlessControllerContainer from './SeamlessControllerContainer';
import NetflixNextEpisode from './NetflixNextEpisode';
import { mobileAndTabletCheck, useDebounce, useStutter } from './utility';
import { useNavigate } from 'react-router-dom';
import { getSrc } from 'features/shared_components';
import { useContainerSize } from './RedQuickLoLoList';
import NextMedias from './NextMedias';

export interface VideoState {
    currentTime: number,
    duration: number,
    volume: number
}

export interface DisneyComponentData {
    video: string,
    title: string,
    imageSrc: string,
    altText: string,
    id: string
}

export default function MediaPlayerComponent(props: {
    url: string,
    title: string,
    episodeTitle: string,
    currentSeason: string,
    currentEpisode: string,
    seasonNumber: number,
    backgroundImage: string,
    series?: ApprovedSeries,
    approvedMedia: ApprovedMedia[],
    processedMedia: ProcessedMedia[],
    episodeNumber: number
    seasons: SeriesSeason[],
    episodes: SeriesEpisode[],
    onPlay: (episode: SeriesEpisode) => void,
    onPlaying: (args: { duration: number, currentTime: number }) => void,
    onChangeSeason: (seasonId) => void,
    onVideoStateChange: (videoState: VideoState) => void
}) {
    let svg_icon_style = { "alignItems": "center", "justifyContent": "normal" };
    const [playing, setPlaying] = useState(false);
    const theme = useTheme();
    const media = useMedia()
    const [play, setPlay] = useState(true);
    const navigate = useNavigate();
    const [muted, setMuted] = useState(false);
    const jump_time = 10;
    const [mutedVolume, setMutedVolume] = useState(3);
    const [volumeValue, setVolumeValue] = useState(3);
    const timelineBar: React.Ref<HTMLDivElement> = React.useRef(null);
    const [player, setPlayer] = useState(null);
    const [duration, setDuration] = useState(null);
    const [currentTime, setCurrentTime] = useState(null);
    const [seekingTime, setSeekingTime] = useState(null);
    const [bufferedEnd, setBufferedEnd] = useState(null);
    const [volume, setVolume] = useState(0);
    const [dragPosition, setDragPosition] = useState(null);
    const [seekPosition, setSeekPosition] = useState(null);
    const [dragging, setDragging] = useState(false);
    const [dragHandler, setDragHandler] = useState(null);
    const [mouseupHandler, setMouseupHandler] = useState(null);
    const [volumeOpen, setVolumeOpen] = useState(false);
    const [playbackRate, setPlaybackRate] = useState(1);
    const [speedOpen, setSpeedOpen] = useState(false);
    const [episodesOpen, setEpisodesOpen] = useState(false);
    const [contextId, setContextId] = useState(null);
    const [userActivity, setUserActivity] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [episodeEnded, setEpisodeEnded] = useState(false);
    const [episodeEnding, setEpisodeEnding] = useState(false);
    const [showControls, setShowControls] = useState(true);
    const [hasShownEnded, setHasShownEnded] = useState(false);
    const componentRef: React.Ref<HTMLDivElement> = React.useRef(null);
    const [disneyComponents, setDisneyComponents] = useState<DisneyComponentData[]>([]);
    const params = useParams();
    const [updated, setUpdated] = useState(null);
    const componentRef_size = useContainerSize(componentRef);
    const currentTimeChangeDebounced = useStutter(currentTime, 200);
    function getDragging() {
        return dragging;
    }
    const cast = useCast({
        initialize_media_player: "DEFAULT_MEDIA_RECEIVER_APP_ID",
        auto_initialize: true,
    })
    const handleClick = useCallback(async () => {
        if (cast?.castReceiver && cast?.handleConnection && !cast?.isConnect) {
            await cast.handleConnection();
        }
    }, [cast?.castReceiver, cast?.handleConnection])
    useEffect(() => {
        if (muted) {
            setMutedVolume(mutedVolume);
            setVolumeValue(0);
        }
        else {
            setVolumeValue(mutedVolume);
        }
    }, [muted]);
    useEffect(() => {
        if (props.onPlaying) {
            props.onPlaying({ duration, currentTime })
        }
    }, [currentTimeChangeDebounced]);
    useEffect(() => {
        if (props.approvedMedia?.length && props.processedMedia?.length) {
            console.log(props.approvedMedia);
            console.log(props.processedMedia);
            let disneyComponents = props.approvedMedia.filter(x => !x.hidden).map((value) => value.media).map((mediaItem) => {
                let sized_url = '';
                let sized_video_url = '';
                sized_video_url = getSrc(mediaItem.mediaPreviewLocation, mediaItem.mediaPreviewUrl, ((componentRef_size?.width || 0) / 8) || 200, [], props.approvedMedia, () => {
                    setUpdated(Date.now());
                });

                sized_url = getSrc(mediaItem.thumbnailLocation, mediaItem.thumbnail, ((componentRef_size?.width || 0) / 8) || 200, [], props.approvedMedia, () => {
                    setUpdated(Date.now())
                });
                if (!sized_url) {
                    return null;
                }
                return {
                    video: sized_video_url || mediaItem.mediaPreviewUrl || mediaItem.mediaRel,
                    title: mediaItem.name,
                    imageSrc: sized_url || mediaItem?.thumbnail,
                    altText: mediaItem.name,
                    id: mediaItem.id
                }
            }).filter(x => x).filter(x => x.id !== params.id);

            let index = Math.ceil(Math.random() * (disneyComponents.length - 6));
            setDisneyComponents(disneyComponents.slice(index, index + 6));

        }
    }, [props?.approvedMedia?.length, props?.processedMedia?.length, params?.id]);
    useEffect(() => {
        if (props.onVideoStateChange) {
            props.onVideoStateChange({
                currentTime: currentTimeChangeDebounced,
                duration,
                volume
            })
        }

    }, [currentTimeChangeDebounced]);

    useEffect(() => {
        let id = uuid();
        setContextId(id);
        context.speed[id] = context.speed[id] || {};
        context.episodes[id] = context.episodes[id] || {};
        bodyWatch({
            id,
            mouseMove: (e, c) => {
                if (context.mousedown) {
                    if (timelineBar.current) {
                        let rect = timelineBar.current.getBoundingClientRect();
                        let offset_left = (e.clientX - rect.left + 12);
                        let total = rect.right - rect.left;
                        setDragPosition(Math.min(1, Math.max(offset_left / total, 0)));
                    }
                }
            },
            mouseUp: () => {
                setDragging(false);
            }
        });
        return () => {
            removeBodyWatch(contextId);
        }
    }, []);
    useEffect(() => {
        if (!dragging) {
            if (player) {
                let seekTime = (duration * dragPosition);
                player.seek(seekTime);
            }
        }
    }, [dragging]);
    useEffect(() => {
        if (player) {
            let seekTime = (duration * seekPosition);
            player.seek(seekTime);
        }

    }, [seekPosition])
    useEffect(() => {
        let timeLeft = duration - currentTime;
        let obj = secondsToHms(timeLeft)
        if (!hasShownEnded && playing && duration && currentTime) {
            if (obj.h === 0 && obj.m === 0 && obj.s < 10) {
                if (!episodeEnding) {
                    setEpisodeEnding(true);
                }
                else {
                    if (obj.h === 0 && obj.m === 0 && obj.s < 2) {
                        setEpisodeEnded(true);
                        setHasShownEnded(true);
                        setPlay(false);
                    }
                }
            }
        }
    }, [currentTime % 1, duration, playing]);

    let progressVisible = duration > 0 && currentTime !== null && duration > currentTime && bufferedEnd !== null;
    let all_episodes = [];
    let season = props?.seasons?.find(v => v.id === props.currentSeason);
    props?.series?.seasons?.forEach((season) => {
        season?.media?.forEach((ep) => {
            all_episodes.push(ep);
        })
    })
    let episodes = props?.episodes?.filter(x => {
        return season?.episodes?.find(v => v === x.id);
    }).map((episode) => {
        return episode;
    });

    let currentEpisode = all_episodes.findIndex(v => v.id === props.currentEpisode);
    let playBtnHandler = async () => {
        setPlay(!playing)
        console.log(`playing: ${playing}`)
        if (media && cast?.isConnect) {
            console.log(`media: ${media}`)
            console.log(media);
            if (!playing) {
                await media.playMedia("http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4");
            }
            else {
                await media.pause();
            }
        }

    }
    let jumpBackHandler = () => {
        if (player && currentTime !== null) {
            player.seek(currentTime - jump_time)
        }
    };
    let jumpForwardHandler = () => {
        if (player && currentTime !== null) {
            player.seek(currentTime + jump_time)
        }
    };
    let playButtonHandlers: any = {
        onClick: playBtnHandler
    }
    let jumpbackHandlers: any = {
        onClick: jumpBackHandler
    }
    let jumpforwardHandlers: any = {
        onClick: jumpForwardHandler
    }
    let isMobile = false;
    if (mobileAndTabletCheck()) {
        isMobile = true;
        // playButtonHandlers = {
        //     onTouchStart: jumpBackHandler
        // }
        // jumpbackHandlers = {
        //     onTouchStart: jumpBackHandler
        // }
        // jumpforwardHandlers = {
        //     onTouchStart: jumpForwardHandler
        // }
    }
    return (
        <div className="media-player-component" ref={componentRef} onTouchStart={() => {
            handleMouseDown(contextId, (v) => setUserActivity(v));
        }} onMouseDown={() => {
            handleMouseDown(contextId, (v) => setUserActivity(v));
        }} onMouseMove={() => {
            handleMouseMove(contextId, (v) => setUserActivity(v));
        }} onKeyDown={() => {
            handleKeyDown(contextId, (v) => setUserActivity(v));
        }}>
            <div className="netflix-sans-font-loaded thisone">
                <div dir="ltr" className="">
                    <div className="watch-video" data-uia="watch-video">
                        <div className="watch-video--player-view" data-uia="watch-video-player-view-minimized">
                            <div className="active ltr-fntwn3 seamless-controller-container netflix-next-episode" style={{ height: '100%', width: '100%' }}
                                data-uia="player" data-videoid="81204752" tabIndex={0}>
                                <div className=" ltr-op8orf" data-uia="video-canvas" style={{ height: '100%', width: '100%' }}>
                                    <div style={{ "position": "relative", "width": "100%", "height": "100%", "overflow": "hidden" }}>
                                        <div id="81204752" style={{ "position": "relative", "width": "100%", "height": "100%", "overflow": "hidden" }}>
                                            <RedQuickVideo
                                                play={play}
                                                url={props.url}
                                                muted={muted}
                                                autoPlay
                                                disableBar
                                                disablePlayButton
                                                containerStyle={{ height: '100%' }}
                                                onStateChanged={(evt: RedQuickVideoState, prevState: RedQuickVideoState, $player: any) => {
                                                    setPlayer($player);
                                                    if (playing === evt.paused) {
                                                        setPlaying(!evt.paused);
                                                    }
                                                    else if (play === true && evt.paused) {
                                                        setPlay(false)
                                                    }
                                                    setVolume(evt.volume);
                                                    setUserActivity(evt.userActivity);
                                                    setIsActive(evt.isActive);
                                                    setPlaybackRate(evt.playbackRate);
                                                    if (evt.buffered.length) {
                                                        let bufferedEnd = evt.buffered.end(evt.buffered.length - 1);
                                                        if (bufferedEnd > evt.duration) {
                                                            bufferedEnd = evt.duration;
                                                        }
                                                        setBufferedEnd(bufferedEnd);
                                                    }
                                                    setCurrentTime(evt.currentTime);
                                                    setDuration(evt.duration);
                                                }}
                                                playerStyle={{ height: '100%' }} />
                                            <div className="player-timedtext" style={{ "position": "absolute", "inset": "289px 0px", "display": "block", "direction": "ltr" }}>
                                                <div className="player-timedtext-text-container" style={{ "display": "block", "whiteSpace": "nowrap", "textAlign": "center", "position": "absolute", "left": "7.14981%", "bottom": "10%" }}>
                                                    <span style={{
                                                        fontSize: 51,
                                                        lineHeight: 'normal',
                                                        fontWeight: 'normal',
                                                        color: '#ffffff',
                                                        textShadow: '#000000 0px 0px 7px',
                                                        fontFamily: 'Netflix Sans,Helvetica Nueue,Helvetica,Arial,sans-serif',
                                                        fontWeight: 'bolder'
                                                    }}></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`ltr-1420x7p ${context.user[contextId] && context.user[contextId].userActivity && (!episodeEnding || showControls) ? 'active' : ''} `} style={{ "alignItems": "normal", "justifyContent": "flex-end" }}>
                                    < div className="ltr-hpbgml" style={{ "alignItems": "flex-start", "flexGrow": "1", "justifyContent": "flex-start" }}>
                                        <div className="ltr-1i33xgl" style={{ "alignItems": "normal", "justifyContent": "normal" }}>
                                            <div className="watch-video--back-container ltr-hpbgml"
                                                onDoubleClick={() => {
                                                    if (player && currentTime !== null) {
                                                        player.seek(currentTime - jump_time)
                                                    }
                                                }}
                                                onClick={() => {
                                                    setPlay(!play)
                                                }}
                                                style={{ "alignItems": "normal", "flexGrow": "1", "justifyContent": "flex-start" }}>
                                                <div className="medium ltr-1dcjcj4" style={{ zIndex: 10000 }}>
                                                    <button aria-label={TitleService("Back")} onClick={() => {
                                                        navigate(-1);
                                                    }} className=" ltr-1enhvti" data-uia="control-nav-back">
                                                        <div className="control-medium ltr-18dhnor" role="presentation">
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M24 11.0001L3.41421 11.0001L8.70711 5.70718L7.29289 4.29297L0.292892 11.293C0.105356 11.4805 0 11.7349 0 12.0001C0 12.2653 0.105356 12.5196 0.292892 12.7072L7.29289 19.7072L8.70711 18.293L3.41421 13.0001H24V11.0001Z" fill="currentColor">
                                                                </path>
                                                            </svg>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="watch-video--flag-container ltr-hpbgml"
                                                onDoubleClick={() => {
                                                    if (player && currentTime !== null) {
                                                        player.seek(currentTime + jump_time)
                                                    }
                                                }}
                                                onClick={() => {
                                                    setPlay(!play)
                                                }}
                                                style={{ "alignItems": "normal", "flexGrow": "1", "justifyContent": "flex-end" }}>
                                                <div className="medium ltr-1dcjcj4">
                                                    <button style={{
                                                        visibility: 'hidden'
                                                    }} aria-label="Signalez un problème de lecture à Netflix." className=" ltr-1enhvti" data-uia="control-flag">
                                                        <div className="control-medium ltr-18dhnor" role="presentation">
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M1 3C0.447715 3 0 3.44772 0 4V10.5714V21H2L2 11.5783C4.05836 11.6067 6.06478 11.7223 8 11.9167V14.5714C8 15.042 8.32807 15.4489 8.78794 15.5487C13.0747 16.4789 17.9011 17 23 17C23.5523 17 24 16.5523 24 16V9.42857C24 8.87629 23.5523 8.42857 23 8.42857C20.5907 8.42857 18.2474 8.30904 16 8.08326V5.42857C16 4.95801 15.6719 4.55111 15.2121 4.45132C10.9253 3.52108 6.09885 3 1 3ZM2 9.57813C4.44972 9.61098 6.83093 9.76415 9.11345 10.0248L10 10.126V11.0183V13.7591C13.6576 14.4969 17.7153 14.9341 22 14.9931V10.4219C19.5503 10.389 17.1691 10.2359 14.8866 9.97522L14 9.87399V8.98168V6.24091C10.3424 5.50309 6.2847 5.06594 2 5.00688V9.57813Z" fill="currentColor">
                                                                </path>
                                                            </svg>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="watch-video--bottom-controls-container ltr-hpbgml" style={{ "alignItems": "flex-end", "justifyContent": "center" }}>
                                        <div className="ltr-jezwko" data-uia="controls-standard" tabIndex={0}>
                                            <div className="ltr-1bt0omd">
                                                <div className="ltr-1i33xgl" style={svg_icon_style}>
                                                    <div className="ltr-hpbgml" style={{ "alignItems": "center", "flexGrow": "1", "justifyContent": "normal" }}>
                                                        {progressVisible && <div aria-orientation="horizontal" className="medium ltr-13q34j2" data-uia="timeline" max="2906320" min={0} role="slider" tabIndex={-1}>
                                                            <div data-uia="timeline-bar" ref={timelineBar} onClick={(evt) => {
                                                                if (timelineBar?.current) {
                                                                    let e = evt.nativeEvent
                                                                    let rect = timelineBar.current.getBoundingClientRect();
                                                                    let offset_left = (e.clientX - rect.left + 12);
                                                                    let total = rect.right - rect.left;
                                                                    setSeekPosition(Math.min(1, Math.max(offset_left / total, 0)));
                                                                }
                                                            }} className="ltr-emvv8v">
                                                                <div className="ltr-xd82k2" style={{
                                                                    "width": `${(bufferedEnd / duration) * 100}%`
                                                                }}>
                                                                </div>
                                                                <div className="ltr-1c4ubff" style={{
                                                                    backgroundColor: theme.palette.secondary.main,
                                                                    "width": `${(currentTime / duration) * 100}%`
                                                                }}>
                                                                </div>
                                                                <div aria-label={TitleService("Progress bar")} onMouseDown={(syntheticEvent) => {
                                                                    let evt = syntheticEvent;
                                                                    evt.preventDefault();
                                                                    setDragging(true);
                                                                    context.mousedown = true;
                                                                }} aria-valuemax="2906320" aria-valuemin={0} aria-valuenow="1749106"
                                                                    aria-valuetext="1749 sur 2906" data-uia="timeline-knob" tabIndex={0} className="ltr-uwc8j6"
                                                                    style={dragging ? {
                                                                        backgroundColor: theme.palette.secondary.main,
                                                                        "left": `calc(${(dragPosition) * 100}% - 12px)`
                                                                    }
                                                                        : {
                                                                            backgroundColor: theme.palette.secondary.main,
                                                                            "left": `calc(${(currentTime / duration) * 100}% - 12px)`
                                                                        }}>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                    </div>
                                                    <div className="ltr-6alejv" style={{ "alignItems": "center", "justifyContent": "center" }}>
                                                        <span className="ltr-pw0kjc" data-uia="controls-time-remaining">{duration ? writeSecondsToHms(duration - (currentTime || 0)) : '00:00'}</span>
                                                    </div>
                                                </div>
                                                <div className="ltr-1i33xgl" style={{ "height": "3rem", "minHeight": "3rem", "minWidth": "100%", "width": "100%" }}>
                                                </div>
                                                <div className="ltr-1bt0omd">
                                                    <div className="ltr-1i33xgl" style={svg_icon_style}>
                                                        <div className="ltr-hpbgml" style={svg_icon_style}>
                                                            <div className="medium ltr-1dcjcj4">
                                                                <button aria-label={TitleService(playing ? 'Pause' : "Play")}
                                                                    {...playButtonHandlers} className=" ltr-1enhvti" data-uia="control-play-pause-pause">
                                                                    <div className="control-medium ltr-18dhnor" role="presentation">
                                                                        {playing && <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-icon-nfplayerPause">
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M4.5 3C4.22386 3 4 3.22386 4 3.5V20.5C4 20.7761 4.22386 21 4.5 21H9.5C9.77614 21 10 20.7761 10 20.5V3.5C10 3.22386 9.77614 3 9.5 3H4.5ZM14.5 3C14.2239 3 14 3.22386 14 3.5V20.5C14 20.7761 14.2239 21 14.5 21H19.5C19.7761 21 20 20.7761 20 20.5V3.5C20 3.22386 19.7761 3 19.5 3H14.5Z" fill="currentColor">
                                                                            </path>
                                                                        </svg>}
                                                                        {!playing && <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                                                            className="svg-icon-nfplayerPlay">
                                                                            <path d="M4 2.69127C4 1.93067 4.81547 1.44851 5.48192 1.81506L22.4069 11.1238C23.0977 11.5037 23.0977 12.4963 22.4069 12.8762L5.48192 22.1849C4.81546 22.5515 4 22.0693 4 21.3087V2.69127Z" fill="currentColor"></path>
                                                                        </svg>}
                                                                    </div>
                                                                </button>
                                                            </div>
                                                            <div className="ltr-1i33xgl  button-spacing" >
                                                            </div>
                                                            <div className="medium ltr-1dcjcj4">
                                                                <button aria-label={TitleService("Jump back")}
                                                                    {...jumpbackHandlers} className=" ltr-1enhvti" data-uia="control-back10">
                                                                    <div className="control-medium ltr-18dhnor" role="presentation">
                                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M11.0198 2.04817C13.3222 1.8214 15.6321 2.39998 17.5557 3.68532C19.4794 4.97067 20.8978 6.88324 21.5694 9.09718C22.241 11.3111 22.1242 13.6894 21.2388 15.8269C20.3534 17.9643 18.7543 19.7286 16.714 20.8192C14.6736 21.9098 12.3182 22.2592 10.0491 21.8079C7.77999 21.3565 5.73759 20.1323 4.26989 18.3439C2.80219 16.5555 2 14.3136 2 12L0 12C-2.74181e-06 14.7763 0.962627 17.4666 2.72387 19.6127C4.48511 21.7588 6.93599 23.2278 9.65891 23.7694C12.3818 24.3111 15.2083 23.8918 17.6568 22.5831C20.1052 21.2744 22.0241 19.1572 23.0866 16.5922C24.149 14.0273 24.2892 11.1733 23.4833 8.51661C22.6774 5.85989 20.9752 3.56479 18.6668 2.02238C16.3585 0.479975 13.5867 -0.214319 10.8238 0.057802C8.71195 0.2658 6.70517 1.02859 5 2.2532V1H3V5C3 5.55229 3.44772 6 4 6H8V4H5.99999C7.45608 2.90793 9.19066 2.22833 11.0198 2.04817ZM2 4V7H5V9H1C0.447715 9 0 8.55229 0 8V4H2ZM14.125 16C13.5466 16 13.0389 15.8586 12.6018 15.5758C12.1713 15.2865 11.8385 14.8815 11.6031 14.3609C11.3677 13.8338 11.25 13.2135 11.25 12.5C11.25 11.7929 11.3677 11.1759 11.6031 10.6488C11.8385 10.1217 12.1713 9.71671 12.6018 9.43389C13.0389 9.14463 13.5466 9 14.125 9C14.7034 9 15.2077 9.14463 15.6382 9.43389C16.0753 9.71671 16.4116 10.1217 16.6469 10.6488C16.8823 11.1759 17 11.7929 17 12.5C17 13.2135 16.8823 13.8338 16.6469 14.3609C16.4116 14.8815 16.0753 15.2865 15.6382 15.5758C15.2077 15.8586 14.7034 16 14.125 16ZM14.125 14.6501C14.5151 14.6501 14.8211 14.4637 15.043 14.0909C15.2649 13.7117 15.3759 13.1814 15.3759 12.5C15.3759 11.8186 15.2649 11.2916 15.043 10.9187C14.8211 10.5395 14.5151 10.3499 14.125 10.3499C13.7349 10.3499 13.4289 10.5395 13.207 10.9187C12.9851 11.2916 12.8741 11.8186 12.8741 12.5C12.8741 13.1814 12.9851 13.7117 13.207 14.0909C13.4289 14.4637 13.7349 14.6501 14.125 14.6501ZM8.60395 15.8554V10.7163L7 11.1405V9.81956L10.1978 9.01929V15.8554H8.60395Z" fill="currentColor">
                                                                            </path>
                                                                        </svg>
                                                                    </div>
                                                                </button>
                                                            </div>
                                                            <div className="ltr-1i33xgl  button-spacing"  >
                                                            </div>
                                                            <div className="medium ltr-1dcjcj4">
                                                                <button aria-label={TitleService("Jump forward")}
                                                                    {...jumpforwardHandlers}
                                                                    className=" ltr-1enhvti" data-uia="control-forward10">
                                                                    <div className="control-medium ltr-18dhnor" role="presentation">
                                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M6.4443 3.68532C8.36794 2.39998 10.6778 1.8214 12.9802 2.04817C14.8093 2.22833 16.5439 2.90793 18 4H16V6H20C20.5523 6 21 5.55228 21 5V1H19V2.2532C17.2948 1.02858 15.288 0.265799 13.1762 0.0578004C10.4133 -0.214321 7.64153 0.479973 5.33315 2.02238C3.02478 3.56479 1.32262 5.85989 0.516716 8.51661C-0.28919 11.1733 -0.148983 14.0273 0.913448 16.5922C1.97588 19.1572 3.8948 21.2744 6.34325 22.5831C8.79169 23.8918 11.6182 24.3111 14.3411 23.7694C17.064 23.2278 19.5149 21.7588 21.2761 19.6127C23.0374 17.4666 24 14.7763 24 12L22 12C22 14.3136 21.1978 16.5555 19.7301 18.3439C18.2624 20.1323 16.22 21.3565 13.9509 21.8079C11.6818 22.2592 9.32641 21.9098 7.28604 20.8192C5.24567 19.7286 3.64657 17.9643 2.76121 15.8269C1.87585 13.6894 1.75901 11.3111 2.4306 9.09717C3.10218 6.88324 4.52065 4.97066 6.4443 3.68532ZM22 4V7H19V9H23C23.5523 9 24 8.55228 24 8V4H22ZM12.6018 15.5758C13.0389 15.8586 13.5466 16 14.125 16C14.7034 16 15.2077 15.8586 15.6382 15.5758C16.0753 15.2865 16.4116 14.8815 16.6469 14.3609C16.8823 13.8338 17 13.2135 17 12.5C17 11.7929 16.8823 11.1758 16.6469 10.6488C16.4116 10.1217 16.0753 9.71671 15.6382 9.43388C15.2077 9.14463 14.7034 9 14.125 9C13.5466 9 13.0389 9.14463 12.6018 9.43388C12.1713 9.71671 11.8385 10.1217 11.6031 10.6488C11.3677 11.1758 11.25 11.7929 11.25 12.5C11.25 13.2135 11.3677 13.8338 11.6031 14.3609C11.8385 14.8815 12.1713 15.2865 12.6018 15.5758ZM15.043 14.0909C14.8211 14.4637 14.5151 14.6501 14.125 14.6501C13.7349 14.6501 13.4289 14.4637 13.207 14.0909C12.9851 13.7117 12.8741 13.1814 12.8741 12.5C12.8741 11.8186 12.9851 11.2916 13.207 10.9187C13.4289 10.5395 13.7349 10.3499 14.125 10.3499C14.5151 10.3499 14.8211 10.5395 15.043 10.9187C15.2649 11.2916 15.3759 11.8186 15.3759 12.5C15.3759 13.1814 15.2649 13.7117 15.043 14.0909ZM8.60395 10.7163V15.8554H10.1978V9.01928L7 9.81956V11.1405L8.60395 10.7163Z" fill="currentColor">
                                                                            </path>
                                                                        </svg>
                                                                    </div>
                                                                </button>
                                                            </div>
                                                            <div className="ltr-1i33xgl  button-spacing">
                                                            </div>
                                                            {!isMobile && <div className="medium ltr-1dcjcj4" onBlur={() => {
                                                                context.volume[contextId] = context.volume[contextId] || {};
                                                                context.volume[contextId].clear = setTimeout(() => {
                                                                    setVolumeOpen(false);
                                                                }, 1000)
                                                            }} onMouseOut={() => {
                                                                context.volume[contextId] = context.volume[contextId] || {};
                                                                context.volume[contextId].clear = setTimeout(() => {
                                                                    setVolumeOpen(false);
                                                                }, 1000)
                                                            }} onFocus={() => {
                                                                context.volume[contextId] = context.volume[contextId] || {};
                                                                if (context.volume[contextId].clear) {
                                                                    clearTimeout(context.volume[contextId].clear)
                                                                }
                                                                setVolumeOpen(true);
                                                            }} onMouseOver={() => {
                                                                context.volume[contextId] = context.volume[contextId] || {};
                                                                if (context.volume[contextId].clear) {
                                                                    clearTimeout(context.volume[contextId].clear)
                                                                }
                                                                setVolumeOpen(true);
                                                            }} >
                                                                <button aria-label={TitleService("Mute")} onClick={() => {
                                                                    setMuted(!muted);
                                                                }} className=" ltr-1enhvti" data-uia="control-volume-off">
                                                                    <div className="control-medium ltr-18dhnor" role="presentation">
                                                                        {volumeValue === 0 && <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                                                                            <path fillRule="evenodd" clipRule="evenodd"
                                                                                d="M11 4.00003C11 3.59557 10.7564 3.23093 10.3827 3.07615C10.009 2.92137 9.57889 3.00692 9.29289 3.29292L4.58579 8.00003H1C0.447715 8.00003 0 8.44774 0 9.00003V15C0 15.5523 0.447715 16 1 16H4.58579L9.29289 20.7071C9.57889 20.9931 10.009 21.0787 10.3827 20.9239C10.7564 20.7691 11 20.4045 11 20V4.00003ZM5.70711 9.70714L9 6.41424V17.5858L5.70711 14.2929L5.41421 14H5H2V10H5H5.41421L5.70711 9.70714ZM15.2929 9.70714L17.5858 12L15.2929 14.2929L16.7071 15.7071L19 13.4142L21.2929 15.7071L22.7071 14.2929L20.4142 12L22.7071 9.70714L21.2929 8.29292L19 10.5858L16.7071 8.29292L15.2929 9.70714Z"
                                                                                fill="currentColor">
                                                                            </path>
                                                                        </svg>}
                                                                        {volumeValue === 3 && <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                                                                            <path fillRule="evenodd" clipRule="evenodd"
                                                                                d="M24 12C24 8.28699 22.525 4.72603 19.8995 2.10052L18.4853 3.51474C20.7357 5.76517 22 8.81742 22 12C22 15.1826 20.7357 18.2349 18.4853 20.4853L19.8995 21.8995C22.525 19.274 24 15.7131 24 12ZM11 4.00001C11 3.59555 10.7564 3.23092 10.3827 3.07613C10.009 2.92135 9.57889 3.00691 9.29289 3.29291L4.58579 8.00001H1C0.447715 8.00001 0 8.44773 0 9.00001V15C0 15.5523 0.447715 16 1 16H4.58579L9.29289 20.7071C9.57889 20.9931 10.009 21.0787 10.3827 20.9239C10.7564 20.7691 11 20.4045 11 20V4.00001ZM5.70711 9.70712L9 6.41423V17.5858L5.70711 14.2929L5.41421 14H5H2V10H5H5.41421L5.70711 9.70712ZM16.0001 12C16.0001 10.4087 15.368 8.8826 14.2428 7.75739L12.8285 9.1716C13.5787 9.92174 14.0001 10.9392 14.0001 12C14.0001 13.0609 13.5787 14.0783 12.8285 14.8285L14.2428 16.2427C15.368 15.1174 16.0001 13.5913 16.0001 12ZM17.0709 4.92896C18.9462 6.80432 19.9998 9.34786 19.9998 12C19.9998 14.6522 18.9462 17.1957 17.0709 19.0711L15.6567 17.6569C17.157 16.1566 17.9998 14.1218 17.9998 12C17.9998 9.87829 17.157 7.84346 15.6567 6.34317L17.0709 4.92896Z"
                                                                                fill="currentColor">
                                                                            </path>
                                                                        </svg>}
                                                                        {volumeValue === 2 && <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                                                                            <path fillRule="evenodd" clipRule="evenodd"
                                                                                d="M11 4.00003C11 3.59557 10.7564 3.23093 10.3827 3.07615C10.009 2.92137 9.57889 3.00692 9.29289 3.29292L4.58579 8.00003H1C0.447715 8.00003 0 8.44774 0 9.00003V15C0 15.5523 0.447715 16 1 16H4.58579L9.29289 20.7071C9.57889 20.9931 10.009 21.0787 10.3827 20.9239C10.7564 20.7691 11 20.4045 11 20V4.00003ZM5.70711 9.70714L9 6.41424V17.5858L5.70711 14.2929L5.41421 14H5H2V10H5H5.41421L5.70711 9.70714ZM17.0709 4.92897C18.9462 6.80433 19.9998 9.34787 19.9998 12C19.9998 14.6522 18.9462 17.1957 17.0709 19.0711L15.6567 17.6569C17.157 16.1566 17.9998 14.1218 17.9998 12C17.9998 9.87831 17.157 7.84347 15.6567 6.34318L17.0709 4.92897ZM14.2428 7.7574C15.368 8.88262 16.0001 10.4087 16.0001 12C16.0001 13.5913 15.368 15.1175 14.2428 16.2427L12.8285 14.8285C13.5787 14.0783 14.0001 13.0609 14.0001 12C14.0001 10.9392 13.5787 9.92176 12.8285 9.17161L14.2428 7.7574Z"
                                                                                fill="currentColor">
                                                                            </path>
                                                                        </svg>}
                                                                        {volumeValue === 1 && <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                                                                            <path fillRule="evenodd" clipRule="evenodd"
                                                                                d="M11 4C11 3.59554 10.7564 3.2309 10.3827 3.07612C10.009 2.92134 9.57889 3.00689 9.29289 3.29289L4.58579 8H1C0.447715 8 0 8.44771 0 9V15C0 15.5523 0.447715 16 1 16H4.58579L9.29289 20.7071C9.57889 20.9931 10.009 21.0787 10.3827 20.9239C10.7564 20.7691 11 20.4045 11 20V4ZM5.70711 9.70711L9 6.41421V17.5858L5.70711 14.2929L5.41421 14H5H2V10H5H5.41421L5.70711 9.70711ZM16.0001 12C16.0001 10.4087 15.368 8.88259 14.2428 7.75737L12.8285 9.17158C13.5787 9.92173 14.0001 10.9391 14.0001 12C14.0001 13.0609 13.5787 14.0783 12.8285 14.8284L14.2428 16.2427C15.368 15.1174 16.0001 13.5913 16.0001 12Z"
                                                                                fill="currentColor">
                                                                            </path>
                                                                        </svg>}
                                                                    </div>
                                                                </button>
                                                                <div className='volume-slide' style={{
                                                                    opacity: volumeOpen ? 1 : 0,
                                                                    pointerEvents: volumeOpen ? '' : 'none'
                                                                }}>
                                                                    <Slider
                                                                        sx={{
                                                                            '& input[type="range"]': {
                                                                                WebkitAppearance: 'slider-vertical',
                                                                            },
                                                                        }}
                                                                        onChange={(event, newValue) => {
                                                                            if (player) {
                                                                                player.volume = ((newValue as number) / 100);
                                                                                if (player.volume === 0) {
                                                                                    setVolumeValue(0);
                                                                                }
                                                                                else {
                                                                                    setVolumeValue(Math.ceil(player.volume * 3));
                                                                                }
                                                                            }
                                                                        }}
                                                                        orientation="vertical"
                                                                        defaultValue={(volume || 0) * 100}
                                                                        value={(volume || 0) * 100}
                                                                        min={0}
                                                                        max={100}
                                                                        aria-label="Temperature"
                                                                        onKeyDown={preventHorizontalKeyboardNavigation}
                                                                    />
                                                                </div>
                                                            </div>}
                                                        </div>
                                                        <div className="ltr-1fkysoc" style={{ "alignItems": "normal", "flexGrow": "1", "justifyContent": "normal" }}>
                                                            <div className="ltr-1i33xgl button-spacing" >
                                                            </div>
                                                            <div className="medium ltr-qnht66" style={{ textAlign: 'left' }} data-uia="video-title">
                                                                <h4>{props.title}</h4>
                                                                {
                                                                    props.series && <>
                                                                        <span>{TitleService('S', 'SEASON_ABBREVIATION')}{props.seasonNumber}&nbsp;:{TitleService('E', 'EPISODE_ABBREVIATION')}&nbsp;{props.episodeNumber}</span>
                                                                        <span>{props.episodeTitle}</span>
                                                                    </>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="ltr-hpbgml" style={{ "alignItems": "normal", "justifyContent": "flex-end" }}>
                                                            {
                                                                props.series && <div className="ltr-1i33xgl button-spacing " >
                                                                </div>
                                                            }
                                                            {props.series && all_episodes.length - 1 > currentEpisode && <div className="medium ltr-1dcjcj4">
                                                                <button aria-label={TitleService("Next episode")}
                                                                    onClick={() => {
                                                                        props.onPlay(all_episodes[currentEpisode + 1]);
                                                                    }}
                                                                    className=" ltr-1enhvti"
                                                                    data-uia="control-next">
                                                                    <div className="control-medium ltr-18dhnor" role="presentation">
                                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M22 3H20V21H22V3ZM4.28615 3.61729C3.28674 3.00228 2 3.7213 2 4.89478V19.1052C2 20.2787 3.28674 20.9977 4.28615 20.3827L15.8321 13.2775C16.7839 12.6918 16.7839 11.3082 15.8321 10.7225L4.28615 3.61729ZM4 18.2104V5.78956L14.092 12L4 18.2104Z" fill="currentColor">
                                                                            </path>
                                                                        </svg>
                                                                    </div>
                                                                </button>
                                                            </div>}
                                                            {props.series && <div className="ltr-1i33xgl  button-spacing">
                                                            </div>}
                                                            {props.series && <div className="medium ltr-1dcjcj4" onBlur={() => {
                                                                context.episodes[contextId].clear = setTimeout(() => {
                                                                    setEpisodesOpen(false);
                                                                    if (props.onChangeSeason) {
                                                                        props.onChangeSeason(null)
                                                                    }
                                                                }, 1000)
                                                            }} onMouseOut={() => {
                                                                context.episodes[contextId].clear = setTimeout(() => {
                                                                    setEpisodesOpen(false);
                                                                    if (props.onChangeSeason) {
                                                                        props.onChangeSeason(null)
                                                                    }
                                                                }, 1000)
                                                            }}>
                                                                <button onFocus={() => {
                                                                    if (context.episodes[contextId].clear) {
                                                                        clearTimeout(context.episodes[contextId].clear)
                                                                    }
                                                                    setEpisodesOpen(true);
                                                                }} onMouseOver={() => {
                                                                    if (context.episodes[contextId].clear) {
                                                                        clearTimeout(context.episodes[contextId].clear)
                                                                    }
                                                                    setEpisodesOpen(true);
                                                                }} aria-label="Épisodes" className=" ltr-1enhvti" data-uia="control-episodes">
                                                                    <div className="control-medium ltr-18dhnor" role="presentation">
                                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M8 5H22V13H24V5C24 3.89543 23.1046 3 22 3H8V5ZM18 9H4V7H18C19.1046 7 20 7.89543 20 9V17H18V9ZM0 13C0 11.8954 0.895431 11 2 11H14C15.1046 11 16 11.8954 16 13V19C16 20.1046 15.1046 21 14 21H2C0.895431 21 0 20.1046 0 19V13ZM14 19V13H2V19H14Z" fill="currentColor">
                                                                            </path>
                                                                        </svg>
                                                                    </div>
                                                                </button>
                                                                <div onFocus={() => {
                                                                    if (context.episodes[contextId].clear) {
                                                                        clearTimeout(context.episodes[contextId].clear)
                                                                    }
                                                                    if (episodesOpen)
                                                                        setEpisodesOpen(true);
                                                                }} onMouseOver={() => {
                                                                    if (context.episodes[contextId].clear) {
                                                                        clearTimeout(context.episodes[contextId].clear)
                                                                    }
                                                                    if (episodesOpen)
                                                                        setEpisodesOpen(true);
                                                                }} className="series-episode-selection episode-selection" style={{
                                                                    opacity: episodesOpen ? 1 : 0,
                                                                    pointerEvents: episodesOpen ? '' : 'none'
                                                                }}>
                                                                    <SeriesEpisodesPopup
                                                                        seriesTitle={props.title}
                                                                        currentSeason={props.currentSeason}
                                                                        currentEpisode={props.currentEpisode}
                                                                        seasons={props.seasons || []}
                                                                        episodes={props.episodes || []}
                                                                        onChangeSeason={seasonId => {
                                                                            if (props.onChangeSeason) {
                                                                                props.onChangeSeason(seasonId);
                                                                            }
                                                                        }}
                                                                        onPlay={(eps: SeriesEpisode) => {
                                                                            props.onPlay(eps);
                                                                        }} />
                                                                </div>
                                                            </div>}
                                                            {/* <div className="ltr-1i33xgl button-spacing" >
                                                            </div>
                                                            <div className="medium ltr-1dcjcj4">
                                                                <button aria-label="Audio et sous-titres" className=" ltr-1enhvti" data-uia="control-audio-subtitle">
                                                                    <div className="control-medium ltr-18dhnor" role="presentation">
                                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M0 4C0 3.44772 0.447715 3 1 3H23C23.5523 3 24 3.44772 24 4V16C24 16.5523 23.5523 17 23 17H19V20C19 20.3688 18.797 20.7077 18.4719 20.8817C18.1467 21.0557 17.7522 21.0366 17.4453 20.8321L11.6972 17H1C0.447715 17 0 16.5523 0 16V4ZM2 5V15H12H12.3028L12.5547 15.1679L17 18.1315V16V15H18H22V5H2ZM10 9H4V7H10V9ZM20 11H14V13H20V11ZM12 13H4V11H12V13ZM20 7H12V9H20V7Z" fill="currentColor">
                                                                            </path>
                                                                        </svg>
                                                                    </div>
                                                                </button>
                                                            </div> */}
                                                            <div className="ltr-1i33xgl button-spacing" >
                                                            </div>
                                                            <div className="medium ltr-1dcjcj4">
                                                                <button aria-label="1&nbsp;× (Normal)" className=" ltr-1enhvti" data-uia="control-speed"
                                                                    onBlur={() => {
                                                                        context.speed[contextId] = context.speed[contextId] || {};
                                                                        context.speed[contextId].clear = setTimeout(() => {
                                                                            setSpeedOpen(false);
                                                                        }, 1000)
                                                                    }} onMouseOut={() => {
                                                                        context.speed[contextId] = context.speed[contextId] || {};
                                                                        context.speed[contextId].clear = setTimeout(() => {
                                                                            setSpeedOpen(false);
                                                                        }, 1000)
                                                                    }} onFocus={() => {
                                                                        context.speed[contextId] = context.speed[contextId] || {};
                                                                        if (context.speed[contextId].clear) {
                                                                            clearTimeout(context.speed[contextId].clear)
                                                                        }
                                                                        setSpeedOpen(true);
                                                                    }} onMouseOver={() => {
                                                                        context.speed[contextId] = context.speed[contextId] || {};
                                                                        if (context.speed[contextId].clear) {
                                                                            clearTimeout(context.speed[contextId].clear)
                                                                        }
                                                                        setSpeedOpen(true);
                                                                    }} >
                                                                    <div className="control-medium ltr-18dhnor" role="presentation">
                                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M17.6427 7.43779C14.5215 4.1874 9.47851 4.1874 6.35734 7.43779C3.21422 10.711 3.21422 16.0341 6.35734 19.3074L4.91474 20.6926C1.02842 16.6454 1.02842 10.0997 4.91474 6.05254C8.823 1.98249 15.177 1.98249 19.0853 6.05254C22.9716 10.0997 22.9716 16.6454 19.0853 20.6926L17.6427 19.3074C20.7858 16.0341 20.7858 10.711 17.6427 7.43779ZM14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12C12.1792 12 12.3528 12.0236 12.518 12.0677L15.7929 8.79289L17.2071 10.2071L13.9323 13.482C13.9764 13.6472 14 13.8208 14 14Z" fill="currentColor">
                                                                            </path>
                                                                        </svg>
                                                                    </div>
                                                                    <div className="control-speed-selection" style={{
                                                                        opacity: speedOpen ? 1 : 0,
                                                                        pointerEvents: speedOpen
                                                                            ? '' : 'none'
                                                                    }}>
                                                                        <PlaybackRateComponent value={playbackRate} onChange={(newValue) => {
                                                                            if (player) {
                                                                                player.playbackRate = newValue;
                                                                            }
                                                                        }} />
                                                                    </div>
                                                                </button>
                                                            </div>
                                                            <div className="ltr-1i33xgl button-spacing" >
                                                            </div>
                                                            {false && <div className="medium ltr-1dcjcj4">
                                                                <button aria-label="Chromecast" onClick={handleClick} style={{
                                                                    color: cast?.isConnect ? 'red' : ''
                                                                }} className=" ltr-1enhvti" data-uia="control-mdx">
                                                                    <div className="control-medium ltr-18dhnor" role="presentation">
                                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                                                                            <path fillRule="evenodd" clipRule="evenodd"
                                                                                d="M0 5C0 3.89543 0.895431 3 2 3H22C23.1046 3 24 3.89543 24 5V19C24 20.1046 23.1046 21 22 21H13C13 20.3288 12.948 19.6602 12.8452 19H22V5H2V8.15477C1.33983 8.05198 0.671206 8 0 8V5ZM2.77164 19.8519C2.9224 20.2159 3 20.606 3 21H0V18C0.393965 18 0.784073 18.0776 1.14805 18.2284C1.51203 18.3791 1.84274 18.6001 2.12132 18.8787C2.3999 19.1573 2.62087 19.488 2.77164 19.8519ZM5 21C5 18.2386 2.76142 16 0 16V14C3.86599 14 7 17.134 7 21H5ZM0 12C4.97056 12 9 16.0294 9 21H11C11 14.9249 6.07513 10 0 10V12Z"
                                                                                fill="currentColor">
                                                                            </path>
                                                                        </svg>
                                                                    </div>
                                                                </button>
                                                            </div>}
                                                            <div className="ltr-1i33xgl button-spacing">
                                                            </div>
                                                            <div className="medium ltr-1dcjcj4">
                                                                <button aria-label={TitleService('Full-screen')} className=" ltr-1enhvti" data-uia="control-fullscreen-enter" onClick={() => {
                                                                    if (player && player.toggleFullscreen) {
                                                                        toggleFullScreen();
                                                                    }
                                                                }}>
                                                                    <div className="control-medium ltr-18dhnor" role="presentation">
                                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard" data-uia="control-fullscreen-enter">
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M0 5C0 3.89543 0.895431 3 2 3H9V5H2V9H0V5ZM22 5H15V3H22C23.1046 3 24 3.89543 24 5V9H22V5ZM2 15V19H9V21H2C0.895431 21 0 20.1046 0 19V15H2ZM22 19V15H24V19C24 20.1046 23.1046 21 22 21H15V19H22Z" fill="currentColor">
                                                                            </path>
                                                                        </svg>
                                                                    </div>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="ltr-1i33xgl" style={{ "height": "3rem", "minHeight": "3rem", "minWidth": "100%", "width": "100%" }}>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <SeamlessControllerContainer
                                    ended={episodeEnded}
                                    backgroundImage={props.backgroundImage}
                                    showControls={showControls}
                                    hasNextEpisode={props?.series && episodes?.length - 1 > currentEpisode}
                                    ending={episodeEnding}>
                                    <NextMedias data={disneyComponents} />
                                    <NetflixNextEpisode onShowControls={() => {
                                        setShowControls(true)
                                    }} onPlay={() => {
                                        props.onPlay(all_episodes[currentEpisode + 1]);
                                    }} />
                                </SeamlessControllerContainer>
                            </div>
                        </div>
                    </div>
                    <div className="visually-hidden screenReaderMessage" role="alert" aria-live="assertive">
                        <span>
                        </span>
                    </div>
                    <div className="visually-hidden" style={{ "display": "none" }}>
                        <div id="standaloneAudioDescriptionAvailable">Audiodescription disponible</div>
                        <div id="episodesAudioDescriptionAvailable">L'audiodescription est disponible pour certains épisodes</div>
                        <div id="playWithAudioDescription">commencer avec l'audiodescription activée</div>
                    </div>
                </div>
            </div>
        </div >
    );
}
function handleMouseDown(id: string, setUserActivate: (v: boolean) => void) {
    startControlsTimer(id, setUserActivate);
}

function handleMouseMove(id: string, setUserActivate: (v: boolean) => void) {
    startControlsTimer(id, setUserActivate);
}

function handleKeyDown(id: string, setUserActivate: (v: boolean) => void) {
    startControlsTimer(id, setUserActivate);
}

function startControlsTimer(id: string, setUserActivate: (v: boolean) => void) {
    let controlBarActiveTime = 3000;

    setUserActivate(true);
    if (context.user[id] && context.user[id].timeout) {
        clearTimeout(context.user[id].timeout);
    }
    context.user[id] = context.user[id] || {};
    context.user[id].userActivity = true;
    context.user[id].timeout = setTimeout(() => {
        setUserActivate(false);
        context.user[id].userActivity = false;
    }, controlBarActiveTime);
}

function toggleFullScreen() {
    if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
    } else {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        }
    }
}

export function PlaybackRateComponent(props: { value: number, onChange: (arg: number) => void }) {
    return (
        <Timeline>
            <TimelineItem onClick={() => {
                props.onChange(.5)
            }}>
                <TimelineOppositeContent>
                    <Typography variant="body2" color="textSecondary">
                        0.5 x
                    </Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                    <TimelineDot color={props.value === .5 ? "primary" : 'secondary'} />
                    <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent>
                    <Typography variant="h2" color="textSecondary">
                        {TitleService('Slow')}
                    </Typography>
                </TimelineContent>
            </TimelineItem>
            <TimelineItem onClick={() => {
                props.onChange(.75)
            }}>
                <TimelineOppositeContent>
                    <Typography variant="body2" color="textSecondary">
                        0.75 x
                    </Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                    <TimelineDot color={props.value === .75 ? "primary" : 'secondary'} />
                    <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent></TimelineContent>
            </TimelineItem>
            <TimelineItem onClick={() => {
                props.onChange(1)
            }}>
                <TimelineOppositeContent>
                    <Typography variant="body2" color="textSecondary">
                        1 x
                    </Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                    <TimelineDot color={props.value === 1 ? "primary" : 'secondary'} />
                    <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent>
                    <Typography variant="h2" color="textSecondary">
                        {TitleService('Normal')}
                    </Typography>
                </TimelineContent>
            </TimelineItem>
            <TimelineItem onClick={() => {
                props.onChange(1.25)
            }}>
                <TimelineOppositeContent>
                    <Typography variant="body2" color="textSecondary">
                        1.25 x
                    </Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                    <TimelineDot color={props.value === 1.25 ? "primary" : 'secondary'} />
                    <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent></TimelineContent>
            </TimelineItem>
            <TimelineItem onClick={() => {
                props.onChange(1.5)
            }}>
                <TimelineOppositeContent>
                    <Typography variant="body2" color="textSecondary">
                        1.5 x
                    </Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                    <TimelineDot color={props.value === 1.5 ? "primary" : 'secondary'} />
                </TimelineSeparator>
                <TimelineContent>
                    <Typography variant="h2" color="textSecondary">
                        {TitleService('Fast')}
                    </Typography>
                </TimelineContent>
            </TimelineItem>
        </Timeline>
    );
}

function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    return { h, m, s }
}

function writeSecondsToHms(d) {
    let { h, m, s } = secondsToHms(d);

    return `${h ? `${h}:` : ''}${`${m}`.padStart(2, '0')}:${`${s}`.padStart(2, '0')}`;
}

function preventHorizontalKeyboardNavigation(event) {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
    }
}
const context = {
    watching: false,
    mousedown: false,
    data: {},
    user: {},
    volume: {},
    speed: {},
    episodes: {}
};
function removeBodyWatch(id) {
    if (context.data[id]) {
        delete context.data[id];
    }
}
function bodyWatch(args: {
    id: string,
    mouseUp: (e: any) => void,
    mouseMove: (e: any, c: any) => void
}) {
    context.data[args.id] = args;
    if (context.watching) {
        return;
    }
    context.watching = true;
    function mouseup(e) {
        context.mousedown = false;
        e = e || window.event;
        e.preventDefault();
        for (let i in context.data) {
            if (context.data[i].mouseUp) {
                context.data[i].mouseUp(e);
            }
        }
    };
    function mousedown(e) {
    }
    let mousemove = e => {
        for (let i in context.data) {
            if (context.data[i].mouseMove) {
                context.data[i].mouseMove(e, context);
            }
        }
    };
    document.body.addEventListener('mousemove', mousemove);
    document.body.addEventListener('mouseup', mouseup);
    document.body.addEventListener('mousedown', mousedown);

}